import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'cleanReply',
  standalone: true
})
/**
 * Diese Pipe entfernt „mx-reply“
 * Begründung: Erforderlich, wenn Nachrichten von dem Element gesendet werden.
 */
export class CleanReplyPipe implements PipeTransform {
  transform(html: string): string {
    if (!html) return '';

    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');

    const mxReplyElements = doc.querySelectorAll('mx-reply');
    mxReplyElements.forEach(el => el.remove());

    const pElements = doc.querySelectorAll('p');
    pElements.forEach(p => {
      const parent = p.parentNode;
      while (p.firstChild) {
        parent?.insertBefore(p.firstChild, p);
      }
      p.remove();
    });

    return doc.body.innerHTML;
  }
}
